import LaddaButton, { SLIDE_UP, XL } from 'react-ladda';
import React, { useState } from 'react';
import { env } from '../../../env';
import moment from 'moment';
import { Observer } from 'mobx-react';
import { SingleDatePicker } from 'react-dates';
import { PrefetchSelect } from '../../profile-modal/tabs/profile-tab-form';
import Select from 'react-select';


const TransferFields = ({
  oldData,
  setTransfers,
}) => {

  const [isDatePickerOpen, setDatePickerOpen] = useState(false);

  const [refreshKey, setRefreshKey] = useState(0);
  const [selectedFrom, setSelectedFrom] = useState(null);
  const [selectedTo, setSelectedTo] = useState(null);
  const [selectedAccount, setSelectedAccount] = useState(oldData.accounts_list ? oldData.accounts_list[0].value : null);


  const [selectedDate, setSelectedDate] = useState(moment().utc());
  const [updatedTransfer, setUpdatedTransfer] = useState();


  const onDateChange = event => {
    setSelectedDate(moment(event._d));
  };

  const handleTransferAdd = async () => {
    if (!selectedDate) return env.alert('Ошибка', `Пожалуйста выберите дату трансфера`);

    try {
      const data = await env.http
        .post('payer/transfers', {
          from: selectedFrom,
          to: selectedTo,
          account_id: selectedAccount,
          transfer_date: selectedDate.format('YYYY-MM-DD HH:mm'),
          payer_id: oldData.id
        })
        .then(response => response.data);
        setTransfers(data);
        setSelectedDate(moment().utc());
        setSelectedFrom(null)
        setSelectedTo(null)
        setSelectedAccount(oldData.accounts_list ? oldData.accounts_list[0].value : null)
        setRefreshKey(refreshKey => refreshKey + 1);

      env.alert('Успех', `Данные успешно сохранены`);
    } catch (e) {
      console.log(e);
      env.alert('Ошибка', `Ошибка. Данные не сохранились.<br /><br /> Тип ошибки: <br />${e.response.data.error_message}`);
    }
  };


  const onEditTransfer = (transferId) => {
    if (transferId !== updatedTransfer) {
      let transferToChange = oldData.transfers.find(transfer => transfer.id === transferId);

      setUpdatedTransfer(transferId);
      setSelectedDate(moment(transferToChange.transfer_date, 'YYYYMMDD'));
      setSelectedFrom(transferToChange.from_user_id)
      setSelectedTo(transferToChange.to_user_id)
      setSelectedAccount(transferToChange.account_id)
      setRefreshKey(refreshKey => refreshKey + 1);

    } else {
      setUpdatedTransfer(null);
      setSelectedDate(null);
      setSelectedFrom(null)
      setSelectedTo(null)
      setSelectedAccount(oldData.accounts_list ? oldData.accounts_list[0].value : null)
      setRefreshKey(refreshKey => refreshKey + 1);
    }
  };


  const handleTransferCancel = () => {
      setUpdatedTransfer(null);
      setSelectedFrom(null)
      setSelectedTo(null)
      setSelectedAccount(oldData.accounts_list ? oldData.accounts_list[0].value : null)
      setSelectedDate(moment().utc());
      setRefreshKey(refreshKey => refreshKey + 1);
  };

  const handleTransferUpdate = async () => {
    
    try {
      const data = await env.http
        .patch(`payer/transfers/${updatedTransfer}`, {
          from: selectedFrom,
          to: selectedTo,
          account_id: selectedAccount,
          transfer_date: selectedDate.format('YYYY-MM-DD HH:mm'),
          payer_id: oldData.id,
          transfer_id: updatedTransfer
        })
        .then(response => response.data);

        setTransfers(data);
        setSelectedDate(moment().utc());
        setSelectedFrom(null)
        setSelectedTo(null)
        setUpdatedTransfer(null);
        setSelectedAccount(oldData.accounts_list ? oldData.accounts_list[0].value : null)
        setRefreshKey(refreshKey => refreshKey + 1);
      env.alert('Успех', `Данные успешно обновлены`);
    } catch (e) {
      console.log(e);
      env.alert('Ошибка', `Ошибка. Данные не обновились.<br /><br /> Тип ошибки: <br />${e.response.data.error_message}`);
    }
  };

  return (
    <>
      <div className='profile-page__headline-title profile-page__headline-title-change-password'>
        Аккаунт:
      </div>
      <Select
        key={`${refreshKey}account`}
        value={selectedAccount}
        onChange={e => setSelectedAccount(e.value)}
        options={oldData.accounts_list}
        isSearchable={true}
        isClearable={false}
        /> 
      <div className='profile-page__headline-title profile-page__headline-title-change-password'>
        От кого:
      </div>
      <PrefetchSelect
          key={`${refreshKey}operator_from`}
          editMode={true}
          current={selectedFrom}
          type="transfer_operators"
          onChange={value => setSelectedFrom(value)}/> 

      <div className='profile-page__headline-title profile-page__headline-title-change-password'>
        К кому
      </div>

      <PrefetchSelect
          key={`${refreshKey}operator_to`}
          editMode={true}
          current={selectedTo}
          type='transfer_operators'
          onChange={value => setSelectedTo(value)}/>

      <div className='profile-page__headline-title profile-page__headline-title-change-password'>
        Дата трансфера
      </div>

      <Observer>
        {() => (<div className='picker-wrapper'>
            <SingleDatePicker
              block
              isOutsideRange={() => false}
              placeholder='Виберите дату'
              focused={isDatePickerOpen}
              date={selectedDate}
              onDateChange={onDateChange}
              onFocusChange={() => setDatePickerOpen(!isDatePickerOpen)}
            />
          </div>)}
      </Observer>

      <LaddaButton
        className='main-form__submit'
        type='submit'
        data-test-id='submitButton'
        data-color='#eee'
        data-size={XL}
        data-style={SLIDE_UP}
        data-spinner-size={30}
        data-spinner-color='#ddd'
        data-spinner-lines={12}
        onClick={!updatedTransfer ? handleTransferAdd : handleTransferUpdate}
      >
        {!updatedTransfer ? "Сохранить" : "Обновить"}
      </LaddaButton>



      <div className='profile-page__headline-title profile-page__headline-title-change-password'>
        Текущие трансферы :
      </div>

      <div style={{ 
        display: 'flex', 
        alignItems: 'center', 
        marginBottom: "10px", 
        padding: "10px", 
        justifyContent: "space-between" 
        }}>
        <p>Дата</p>
        <p>Аккаунт</p>
        <p>От кого</p>
        <p>Кому</p>
        <p>Действие</p>

      </div>
        {oldData.transfers.map((payerTransfer, index) => (<div key={index} style={{ 
          display: 'flex', 
          alignItems: 'center', 
          justifyContent: "space-between" 
          }}>
            <p>{moment(payerTransfer.transfer_date, 'YYYYMMDD').format('DD.MM.YYYY')}</p>
            <p>{payerTransfer.account_name}</p>
            <p>{payerTransfer.from_user}</p>
            <p>{payerTransfer.to_user}</p>

            <div>
                {(updatedTransfer === payerTransfer.id) && (<button
                  className='popup__btn popup__btn_cancel js-popup-edit-cancel'
                  onClick={() => handleTransferCancel(payerTransfer.id)}
                >
                  <svg
                    className='icon icon-cancel'
                    id='icon-cancel'
                    viewBox='0 0 15.5 15.5'
                    width='100%'
                    height='100%'
                  >
                    <path
                      d='M7.75.25A7.5 7.5 0 0 0 2.31 2.6l-.03.02A7.45 7.45 0 0 0 .25 7.75a7.5 7.5 0 1 0 7.5-7.5zm-6.29 7.5c0-1.43.48-2.75 1.29-3.81l8.81 8.81a6.3 6.3 0 0 1-10.1-5zm10.98 4.17L3.58 3.06a6.3 6.3 0 0 1 8.86 8.86z' />
                    <path
                      strokeMiterlimit='50'
                      strokeWidth='.5'
                      d='M7.75.25A7.5 7.5 0 0 0 2.31 2.6l-.03.02A7.45 7.45 0 0 0 .25 7.75a7.5 7.5 0 1 0 7.5-7.5zm-6.29 7.5c0-1.43.48-2.75 1.29-3.81l8.81 8.81a6.3 6.3 0 0 1-10.1-5zm10.98 4.17L3.58 3.06a6.3 6.3 0 0 1 8.86 8.86z'
                    />
                  </svg>
                </button>)}

                {(updatedTransfer !== payerTransfer.id) && (
                <button className='popup__btn popup__btn_edit js-popup-edit'
                        onClick={() => onEditTransfer(payerTransfer.id)}
                        >
                  <svg
                    className='icon icon-pencil-black'
                    id='icon-pencil'
                    viewBox='0 0 15 15'
                    width='100%'
                    height='100%'
                  >
                    <path
                      d='M8.71 2.34l2.84 2.86-7.21 7.24L1.5 9.58zm5 .69L12.3 4.45 9.45 1.59 10.66.37c.5-.49 1.29-.49 1.78 0l1.27 1.28c.39.38.39 1 0 1.38zM.01 13.6c-.05.24.16.45.39.39l3.17-.77-2.84-2.86z' />
                  </svg>
                </button>)}
              </div>
          </div>))}

    </>
  );
};

export default TransferFields;